import gql from 'graphql-tag';

export default gql`
  mutation play {
    play @client
  }
`;



// WEBPACK FOOTER //
// ./src/@data/mediaPlayer/playMutation.js